import React, { useEffect, useRef, useState } from "react";
import DOMPurify from "dompurify";
import { Link, useLocation, useParams } from "react-router-dom";
import Slider from "react-slick";
import axios from "axios";

import { GET_PRODUCT_API, POST_ADD_WISHLIST_API } from "../app/constants";
import { BASE_URL } from "..";
import Card from "../Card";
import useHomeStore from "./ZustandStore/useHomeStore";
import DynamicMetaTags from "../helper/DynamicMetaTags";
import { Controller, useForm } from "react-hook-form";
import ProductDetailSkeleton from "./Skeletons/ProductDetailSkeleton";
import BtnLoader from "./BtnLoader";
import Notification from "../helper/Notification";
const ProductDetailsOne = () => {
  const { fetchCountProduct, handleAddToCart, fetchData } = useHomeStore();
  const [quantity, setQuantity] = useState(1); // Manage quantity as local state

  const incrementQuantity = () => setQuantity((prev) => prev + 1); // Increment quantity
  const decrementQuantity = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1); // Decrement quantity
    }
  };

  const [productData, setProductData] = useState({});

  const [brand, setBrand] = useState({});
  const [category, setCategory] = useState({});
  const [productImages, setProductImages] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const [overview, setOverview] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const { slug } = useParams();
  const location = useLocation();
  const currentURL = `${window.location.origin}${location.pathname}`;

  useEffect(() => {
    fetchProductDetails();
  }, [slug]);

  const fetchProductDetails = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}${GET_PRODUCT_API}/${slug}`);
      if (response.status === 200 && response.data.code === 1) {
        const metaTags = response.data.data;
        useHomeStore.getState().setMetaTags(metaTags);
        const product = response.data.data;
        setProductData(product);
        setBrand(product.brandDTO);
        setCategory({
          parent: product.parentCategory,
          child: product.childCategory,
        });
        setProductImages([
          product.image,
          ...product.productImageDTOList.map((img) => img.url),
        ]);
        setInventory(product.inventoryMap);
        setVideoUrl(product.video);
        setOverview(product.overview);
      } else {
        setShowNotification(response.data.message);
        throw new Error(
          response.data.message || "Failed to fetch product data."
        );
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddToWishlist = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.post(
        `${BASE_URL}${POST_ADD_WISHLIST_API}?productId=${productData.productId}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.code === 1) {
        fetchCountProduct();

        setShowWishListNotification(response.data.message);
      } else {
        console.error("Failed to add item to wishlist");
      }
    } catch (error) {
      console.error("Error adding item to wishlist:", error);
    }
  };

  // Get the navigate function from useNavigate

  const settingsThumbs = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    focusOnSelect: true,
  };

  const [mainImage, setMainImage] = useState(productImages[0]);

  useEffect(() => {
    if (productImages.length > 0) {
      setMainImage(productImages[0]);
    }
  }, [productImages]);
  const sanitizedOverview = DOMPurify.sanitize(productData.overview);
  const sanitizedDescription = DOMPurify.sanitize(productData.description);

  const [isExpanded, setIsExpanded] = useState(false);

  // Function to toggle the expanded state
  const toggleReadMore = () => {
    setIsExpanded((prevState) => !prevState);
  };

  useEffect(() => {
    setIsExpanded(false);
  }, [slug]);
  const [totalLines, setTotalLines] = useState(0);
  const descriptionRef = useRef(null);

  // Calculate totalLines dynamically based on content
  useEffect(() => {
    if (descriptionRef.current) {
      const lineHeight = parseFloat(
        window.getComputedStyle(descriptionRef.current).lineHeight
      );
      const totalHeight = descriptionRef.current.scrollHeight;
      const calculatedLines = Math.ceil(totalHeight / lineHeight);
      setTotalLines(calculatedLines);
    }
  }, [sanitizedDescription]);

  const deliveryImages = [
    "/assets/images/icon/standard-delivery.png", // First feature's image
    "/assets/images/icon/cash-delivery.png", // Second feature's image
    "/assets/images/icon/return.png", // Third feature's image
  ];

  const [btnLoader, setBtnLoader] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [showWishListNotification, setShowWishListNotification] =
    useState(false);

  const handleClick = async (e) => {
    setBtnLoader(true); // Set loading to true
    try {
      await handleAddToCart(
        productData.inventoryMap?.["Warranty Type"]?.[0]?.id,
        quantity
      );
      await fetchCountProduct();
      e.preventDefault();
      setShowNotification(true);
    } catch (error) {
      console.error("Error handling add to cart:", error);
    } finally {
      setBtnLoader(false); // Reset loading state
    }
  };

  return (
    <section className="product-details py-20 px-12">
      {/* Popup */}
      {/* <Notification
        show={showNotification}
        type="success" // "success", "error", or "warning"
        message="Your product has been added in cart!"
        onClose={() => setShowNotification(false)} // Callback when closed
      /> */}
      {/* <Notification
        show={showWishListNotification}
        type="success"
        message="Your product has been added to wishlist!"
        onClose={() => setShowWishListNotification(false)}
      /> */}
      {/* Popup end*/}

      <DynamicMetaTags />
      {isLoading ? (
        <ProductDetailSkeleton />
      ) : (
        <div className="container container-lg">
          <p className="text-truncate mb-20 px-30">
            {productData.parentCategory
              ? productData.parentCategory.title
              : "Category"}
            {" > "}
            {productData.childCategory
              ? productData.childCategory.title
              : "Subcategory"}
            {" > "}
            {productData.title ? productData.title : "Product"}
          </p>

          <div className="row gy-4">
            <div className="col-xl-9">
              <div className="row gy-4">
                <div className="col-xl-6">
                  <div>
                    {/* Main Image */}
                    <img
                      src={mainImage}
                      alt="Main Product"
                      style={{
                        width: "100%",
                        objectFit: "contain",
                        minHeight: "30rem",
                        maxHeight: "30rem",
                      }}
                    />

                    {/* Slider Section */}
                    <div style={{ marginTop: "1.5rem" }}>
                      {productData.productImageDTOList?.length === 0 ||
                      !productData.productImageDTOList ? (
                        <div>
                          <img
                            src={productData.image}
                            alt="Main Product Image"
                            style={{
                              objectFit: "contain",
                              width: "100%",
                              minHeight: "5rem",
                              maxHeight: "5rem",
                            }}
                          />
                        </div>
                      ) : (
                        // If productImageDTOList has images, render the slider
                        <Slider {...settingsThumbs} style={{ width: "100%" }}>
                          {productImages.map((img, idx) => (
                            <div
                              key={idx}
                              onClick={() => setMainImage(img)}
                              className={`color-box cursor-pointer rounded-3 border border-2 ${
                                mainImage === img
                                  ? "border-1 border-main-600"
                                  : "border-light"
                              }`}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minWidth: "5rem",
                              }}
                            >
                              <img
                                src={img}
                                alt={`Product Image ${idx + 1}`}
                                style={{
                                  objectFit: "contain",
                                  width: "100%",
                                  minHeight: "5rem",
                                  maxHeight: "5rem",
                                }}
                              />
                            </div>
                          ))}
                        </Slider>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-xl-6">
                  <div className="product-details__content">
                    <h5 className="mb-12">{productData.title}</h5>
                    <div className="flex-align flex-wrap gap-12">
                      <div className="flex-align gap-12 flex-wrap">
                        <div></div>
                        <div className="flex-align gap-8">
                          {/* Loop through 5 stars */}
                          {(() => {
                            const rating = productData.averageRating; // Example rating
                            const fullStars = Math.floor(rating); // Full stars
                            const hasHalfStar = rating % 1 >= 0.5; // Check for half star
                            const stars = [];

                            // Push full stars
                            for (let i = 0; i < fullStars; i++) {
                              stars.push("full");
                            }

                            // If there's a half star
                            if (hasHalfStar) {
                              stars.push("half");
                            }

                            // Fill the remaining stars with empty ones
                            while (stars.length < 5) {
                              stars.push("empty");
                            }

                            return stars.map((star, index) => (
                              <span
                                key={index}
                                className="text-15 --bs-warning fw-medium d-flex"
                              >
                                {/* Display full, half, or empty star */}
                                <i
                                  className={`${
                                    star === "empty"
                                      ? "bi bi-star text-warning" // Empty star
                                      : "bi bi-star-fill text-warning" // Full star with color
                                  } ${
                                    star === "half"
                                      ? "bi bi-star-half text-warning"
                                      : ""
                                  }`}
                                />
                              </span>
                            ));
                          })()}
                        </div>
                        <span className="text-sm fw-medium text-gray-500">
                          {`${productData.reviewCount} Reviews`}
                        </span>

                        {/*  */}
                        <div className="container py-4">
                          {/* Ratings */}
                          <div className="d-flex align-items-center mb-4">
                            {productData.rating && (
                              <span className="badge bg-success text-white fs-6 py-2 px-3">
                                {productData.rating}★
                              </span>
                            )}
                            {productData.reviews && (
                              <span className="ms-3 text-muted">
                                {productData.reviews} ratings and
                                {productData.totalReviews} reviews
                              </span>
                            )}
                          </div>

                          {/* Colors */}
                          {productData.inventoryMap && (
                            <div className="mb-4">
                              <table className="table">
                                <tbody>
                                  <tr>
                                    <td
                                      className="fw-bold"
                                      style={{ width: "30%" }}
                                    >
                                      <h6 className="fs-6">Color</h6>
                                    </td>
                                    <td style={{ width: "70%" }}>
                                      <div className="d-flex gap-3">
                                        {Object.entries(
                                          productData.inventoryMap
                                        ).map(([attribute, values]) =>
                                          values
                                            .filter(
                                              (value) => value.inventoryImage
                                            ) // Only include items with an image
                                            .map((value, index) => (
                                              <div
                                                key={`${attribute}-${index}`}
                                                onClick={() =>
                                                  setMainImage(
                                                    value.inventoryImage
                                                  )
                                                }
                                                className={`color-box cursor-pointer rounded-3 border border-2 ${
                                                  mainImage ===
                                                  value.inventoryImage
                                                    ? "border-1 border-main-600"
                                                    : value.selected
                                                    ? "border-success"
                                                    : "border-light"
                                                }`}
                                                style={{
                                                  minWidth: "50px",
                                                  maxWidth: "50px",
                                                  minHeight: "50px",
                                                  maxHeight: "50px",
                                                }}
                                              >
                                                <img
                                                  src={value.inventoryImage}
                                                  alt={`Color ${index + 1}`}
                                                  style={{
                                                    objectFit: "cover",
                                                    width: "100%",
                                                    height: "100%",
                                                  }}
                                                />
                                              </div>
                                            ))
                                        )}
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          )}

                          {/* Refundable/Warranty */}
                          <div className="mt-4">
                            <table className="table">
                              <tbody>
                                {/* Refundable Row */}
                                {/* <tr>
                                <td
                                  className="fw-bold"
                                  style={{ width: "30%" }}
                                >
                                  <h6 className="fs-6 mb-1">Refundable</h6>
                                </td>
                                <td style={{ width: "70%" }}>
                                  <strong>
                                    {productData.refundable ? "Yes" : "No"}
                                  </strong>
                                </td>
                              </tr> */}
                                {/* Warranty Row */}
                                <tr>
                                  <td
                                    className="fw-bold"
                                    style={{ width: "30%" }}
                                  >
                                    <h6 className="fs-6 mb-1">Warranty</h6>
                                  </td>
                                  <td style={{ width: "70%" }}>
                                    <strong>
                                      {productData.warranty
                                        ? productData.warranty
                                        : "No Warranty"}
                                    </strong>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          {/* Other Details */}
                          <table className="table mt-4">
                            <tbody>
                              {productData.details &&
                                Object.entries(productData.details).map(
                                  ([key, value]) => (
                                    <tr key={key}>
                                      <td
                                        className="fw-bold bg-light"
                                        style={{ width: "30%" }}
                                      >
                                        {key}
                                      </td>
                                      <td style={{ width: "70%" }}>{value}</td>
                                    </tr>
                                  )
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <span className="mt-14 text-gray-700 border-top border-gray-100 d-block" />
                    <div
                      className="mt-32"
                      dangerouslySetInnerHTML={{
                        __html: sanitizedOverview,
                      }}
                    ></div>
                    <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-3">
              <div className="product-details__sidebar  px-32 rounded-16">
                {/* <div className="mb-32"> <label htmlFor="delivery" className="h6 activePage mb-8 text-heading fw-semibold d-block" > Delivery </label> <div className="flex-align border border-gray-100 rounded-4 px-16"> <span className="text-xl d-flex text-main-600"> <i className="ph ph-map-pin" /> </span> <select defaultValue={1} className="common-input border-0 px-8 rounded-4" id="delivery" > <option value={1}>Maymansign</option> <option value={1}>Khulna</option> <option value={1}>Rajshahi</option> <option value={1}>Rangpur</option> </select> </div> </div> */}
                <div>
                  <div className="flex-align flex-wrap gap-8 border-bottom border-gray-100 mb-10">
                    <h3 className="mb-0">Rs.{productData.offered} </h3>
                    <span
                      className="text-decoration-line-through"
                      style={{ color: "gray" }}
                    >
                      Rs.{productData.selling}
                    </span>
                  </div>
                </div>
                <div className="">
                  <div className="flex-align rounded-4 overflow-hidden">
                    <p>Quantity</p>

                    {/* Decrement Button */}
                    <button
                      onClick={decrementQuantity}
                      type="button"
                      className="quantity__minus rounded-start-3 ms-20 flex-shrink-0 h-48 w-48 text-neutral-600 border-gray-100 flex-center hover-bg-main-600 hover-text-white bg-gray-50"
                    >
                      <i className="ph ph-minus" />
                    </button>

                    {/* Quantity Input */}
                    <input
                      value={quantity} // Bind the quantity state to the input
                      onChange={(e) => setQuantity(Number(e.target.value))} // Update state on input change
                      type="number"
                      className="quantity__input border border-gray-100 border-start-0 border-end-0 text-center w-40 h-100"
                      style={{ minHeight: "3rem" }}
                      id="stock"
                      min="1"
                    />

                    {/* Increment Button */}
                    <button
                      onClick={incrementQuantity}
                      type="button"
                      className="quantity__plus rounded-end-3 flex-shrink-0 h-48 w-48 text-neutral-600 border-gray-100 flex-center hover-bg-main-600 hover-text-white bg-gray-50"
                    >
                      <i className="ph ph-plus" />
                    </button>
                  </div>

                  {/* Add to Cart Button */}
                  <button
                    onClick={handleClick}
                    className="btn btn-main flex-center gap-8 rounded-8 py-16 fw-normal mt-12 w-100"
                    disabled={btnLoader} // Disable button while loading
                  >
                    {!btnLoader && (
                      <i className="ph ph-shopping-cart-simple text-lg" />
                    )}{" "}
                    {/* Show icon only when not loading */}
                    {btnLoader ? <BtnLoader /> : "Add To Cart"}
                  </button>
                </div>
                <Link
                  to="#"
                  className="btn btn-outline-main rounded-8 py-16 fw-normal mt-16 w-100"
                >
                  Buy Now
                </Link>
                <div className="mt-12">
                  {/* <p>
                    <i
                      className="ph-fill ph-lock"
                      style={{ marginRight: "8px" }}
                    />
                    Secure transaction
                  </p>
                  <p>Arrives : Sunday, Nov 17</p> */}
                  {productData.deliveryFeatures &&
                    productData.deliveryFeatures.map((feature, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                        }}
                      >
                        <img
                          src={
                            deliveryImages[index] ||
                            "/assets/images/icon/default.png"
                          }
                          alt={`Feature ${index + 1}`}
                          style={{
                            width: (index + 1) === 3 ? "25px" : "30px",
                            height: (index + 1) === 3 ? "25px" : "30px",
                            marginLeft: (index + 1) === 3 ? "3px" : "0",
                            marginTop: (index + 1) === 3 ? "3px" : "0",
                          }}
                        />
                        <span className="my-10 mx-4">{feature}</span>
                      </div>
                    ))}

                  <Link
                    to="#"
                    className="btn btn-outline-main rounded-8 py-16 fw-normal mt-12 w-100"
                    onClick={handleAddToWishlist}
                  >
                    Add to Whislist
                  </Link>
                </div>
                <div className="mt-12 flex-align gap-10">
                  <p>Share:</p>
                  <div>
                    <ul className="flex-align">
                      {/* Facebook */}
                      <li>
                        <a
                          href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                            currentURL
                          )}`}
                          className="w-44 h-44 flex-center text-xl"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i
                            className="ph-fill ph-facebook-logo"
                            style={{ color: "#1877F2" }}
                          />
                        </a>
                      </li>

                      {/* WhatsApp */}
                      <li>
                        <a
                          href={`https://wa.me/?text=${encodeURIComponent(
                            `Check this out: ${productData.title} at ${currentURL}`
                          )}`}
                          className="w-44 h-44 flex-center text-xl"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i
                            className="ph-fill ph-whatsapp-logo"
                            style={{ color: "#25D366" }}
                          />
                        </a>
                      </li>

                      {/* Pinterest */}
                      <li>
                        <a
                          href={`https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
                            currentURL
                          )}&description=${encodeURIComponent(
                            productData.title
                          )}`}
                          className="w-44 h-44 flex-center text-xl"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i
                            className="ph-fill ph-pinterest-logo"
                            style={{ color: "#E60023" }}
                          />
                        </a>
                      </li>
                      {/* Twitter */}
                      <li>
                        <a
                          href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                            `Check this out: ${productData.title} at ${currentURL}`
                          )}`}
                          className="w-44 h-44 flex-center text-xl"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i
                            className="ph-fill ph-twitter-logo"
                            style={{ color: "#1DA1F2" }}
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <section
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
            >
              <div
                className="mt-12"
                style={{
                  flex: "0 1 calc(100% - 20px)",
                  boxSizing: "border-box",
                }}
              >
                <div
                  ref={descriptionRef}
                  style={{
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    WebkitLineClamp: isExpanded ? totalLines : "3",
                    transition: "all 0.3s ease",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: sanitizedDescription,
                  }}
                ></div>
                {totalLines > 4 && (
                  <>
                    {!isExpanded && (
                      <div
                        style={{
                          background:
                            "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)",
                        }}
                      ></div>
                    )}
                    <button
                      className="btn btn-outline-main fw-normal mt-10"
                      onClick={toggleReadMore}
                    >
                      {isExpanded ? "Read Less" : "Read More"}
                    </button>
                  </>
                )}
              </div>
            </section>

            <div>
              <h2 className="mb-0 text-2xl">Similar Products</h2>
              <section
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "20px",
                  justifyContent: "flex-start",
                  alignItems: "flex-start",
                }}
              >
                {productData?.similarProducts?.length > 0 ? (
                  productData.similarProducts.map((product) => (
                    <div
                      key={product.id}
                      id={`product-${product.id}`}
                      style={{
                        flex: "0 1 calc(20% - 20px)",
                        boxSizing: "border-box",
                      }}
                    >
                      <Card
                        imageSrc={product.image}
                        title={product.title}
                        badge={product.badge}
                        offered={product.selling}
                        purchased={product.offered}
                        averageRating={product.averageRating}
                        reviewCount={product.reviewCount}
                        productViews={product.productViews}
                        soldOut={product.soldOut}
                        productLink={`/product/${product.slug}`}
                        productInventoryId={
                          product.inventoryMap?.defaultInventory?.[0]?.id ||
                          null
                        }
                      />
                    </div>
                  ))
                ) : (
                  <p>No similar products available</p>
                )}
              </section>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductDetailsOne;
